import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './MailingListForm.scss'; 

function MailingListForm() {
  // Replace "YOUR_FORM_ID" with your actual Formspree Form ID
  const [state, handleSubmit] = useForm("mvgazpgb");

  if (state.succeeded) {
      return <p>Thanks for joining!</p>; // Success message
  }

  return (
      <form onSubmit={handleSubmit} className="formMain">
          {/* <label htmlFor="email">
              Join our mailing list:
          </label> */}
          <input
              id="email"
              type="email"
              name="email" // Use 'email' as the name attribute
              required
              placeholder="enter email"
              className="inputForm"
          />
          {/* Input field validation error */}
          <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
          />

          {/* General submission error */}
          <ValidationError
              errors={state.errors}
          />

          <button type="submit" disabled={state.submitting} className="submitButton">
              {state.submitting ? 'Signing Up...' : 'Sign Up'}
          </button>
      </form>
  );
}

export default MailingListForm;